import { Box, Divider, Stack, Typography, useTheme } from '@mui/material'

const ColoringGroupedElements = () => {
  const theme = useTheme()

  return (
    <Stack p={2} spacing={1}>
      <Stack direction="row" spacing={1} flex={1} alignItems="center">
        <Box
          sx={{
            width: 10,
            height: 10,
            backgroundColor: theme.scenePalette.representatives.representative as string,
            borderRadius: 10,
          }}
        />
        <Box>
          <Typography>Representativ</Typography>
        </Box>
      </Stack>

      <Divider />

      <Stack direction="row" spacing={1} flex={1} alignItems="center">
        <Box
          sx={{
            width: 10,
            height: 10,
            backgroundColor: theme.scenePalette.representatives.representativeFor as string,
            borderRadius: 10,
          }}
        />

        <Box>
          <Typography>Representativ für</Typography>
        </Box>
      </Stack>
    </Stack>
  )
}

export default ColoringGroupedElements
